var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',_vm._g(_vm._b({staticClass:"f-grid-column",class:_vm._class,style:(_vm._style)},'th',_vm.$attributes,false),_vm.$events),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }